import axios from "axios";
import { createLogger } from "../../helper/logger";

// Create logger instance
const logger = createLogger("APIServices");

// Check if we're in mock authentication mode
const isFakeAuth =
	process.env.REACT_APP_AUTH_FAKE_IT === "YES" ||
	process.env.REACT_APP_AUTH_FAKE_IT === "TRUE";

// Mock response generator - can be expanded for different API patterns
const generateMockResponse = (url) => {
	logger.debug("Generating mock response", { url });

	// Default mock response
	return {
		status: "success",
		message: "This is mock data from the fake backend",
		data: [],
	};
};

export const getAPI = async (_url, token = "") => {
	try {
		// Return mock data if authentication is faked
		if (isFakeAuth) {
			logger.debug("GET request intercepted in mock mode", { url: _url });
			// Simulate network delay
			await new Promise((resolve) => setTimeout(resolve, 300));

			// Return mock data or let specific service handlers manage it
			// This is just a fallback for any unhandled API calls
			return { data: generateMockResponse(_url), loading: false, error: null };
		}

		const config = {
			method: "get",
			maxBodyLength: Number.POSITIVE_INFINITY,
			url: _url,
			headers: {
				"Content-Type": "application/json",
				Authorization: token,
			},
		};

		const response = await axios.request(config);
		return { data: response.data, loading: false, error: null };
	} catch (error) {
		return { data: null, loading: false, error: error };
	}
};

export const postAPI = async (_url, _body, token = "") => {
	try {
		// Return mock data if authentication is faked
		if (isFakeAuth) {
			logger.debug("POST request intercepted in mock mode", {
				url: _url,
				body: _body,
			});
			// Simulate network delay
			await new Promise((resolve) => setTimeout(resolve, 300));

			// Return mock data or let specific service handlers manage it
			// This is just a fallback for any unhandled API calls
			return {
				data: "Operation completed successfully",
				loading: false,
				error: null,
			};
		}

		const config = {
			method: "post",
			url: _url,
			headers: {
				"Content-Type": "application/json",
				Authorization: token,
			},
			data: _body,
		};
		const response = await axios.request(config);
		return { data: response.data, loading: false, error: null };
	} catch (error) {
		return { data: null, loading: false, error: error };
	}
};
